import React from "react";
import { Box, Container, Grid, Typography, IconButton, Link } from "@mui/material";
import { Facebook, Instagram, WhatsApp, Close, ChevronRight } from "@mui/icons-material";
import imgae1 from '../../assets/image/secured-badges9.png'
import logo from '../../assets/image/ZOOdonix-logo.png'
import paymentMethod from '../../assets/image/payment-methods.webp'
const Footer = () => {
  return (
    <Box sx={{ background: "linear-gradient(to right, #2D0B5A, #C106A3)", color: "white", pt: 4 }}>
      <Box sx={{ p: 1 }}>
        <Grid container spacing={4}>
          {/* Left Section */}
          <Grid item xs={12} md={3}>
            <Box display="flex" alignItems="center" gap={1}>
              <img src={logo} alt="Logo" width={200} />
            </Box>
            <Typography sx={{ mt: 2 }}>
              <strong>ZOODONIX</strong>
              - puts together a bunch of passionate minds to transform your visions into reality imparting an awesome digital experience for your users. From website design, development, scalable mobile apps to SaaS platforms, the solution we engineer accelerate efficiency and fuel growth for our clients.  🚀
            </Typography>
            <Box mt={2} display="flex" gap={1}>
              <IconButton sx={{ bgcolor: "#ff005a", color: "white" }}><Close /></IconButton>
              <IconButton sx={{ bgcolor: "#ff005a", color: "white" }}><Facebook /></IconButton>
              <IconButton sx={{ bgcolor: "#ff005a", color: "white" }}><Instagram /></IconButton>
              <IconButton sx={{ bgcolor: "#ff005a", color: "white" }}><WhatsApp /></IconButton>
            </Box>
          </Grid>

          {/* Explore Section */}
          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6" fontWeight="bold">Explore ZOODONIX</Typography>
            {["About Us", "Our Products", "Add-on Services", "Membership Packages", "Web Design Packages", "Blog"].map((text) => (
              <Typography key={text} sx={{ mt: 1, display: "flex", alignItems: "center", cursor: "pointer", "&:hover": { textDecoration: "underline" } }}>
                <ChevronRight fontSize="small" sx={{ mr: 1, background: '#FFCC00', borderRadius: '50%', color: 'black' }} /> {text}
              </Typography>
            ))}
          </Grid>

          {/* Categories */}
          <Grid item xs={6} sm={6} md={2} >
            <Typography variant="h6" fontWeight="bold">Our Services</Typography>
            {["One Page Websites", "Small Business Websites", "E-Commerce Websites", "Online Portals", "Money Making Websites", "View all Categories"].map((text) => (
              <Typography key={text} sx={{ mt: 1, display: "flex", alignItems: "center", cursor: "pointer", "&:hover": { textDecoration: "underline",   } }}>
                <ChevronRight fontSize="small" sx={{ mr: 1, background: '#FFCC00', borderRadius: '50%', color: 'black' }} /> {text}
              </Typography>
            ))}
          </Grid>

          {/* For Members */}
          <Grid item xs={6} sm={6} md={2}>
            <Typography variant="h6" fontWeight="bold">Import</Typography>
            {["My Account", "Order History", "Downloads", "FAQs", "Support Packages", "Contact Us"].map((text) => (
              <Typography key={text} sx={{ mt: 1, display: "flex", alignItems: "center", cursor: "pointer", "&:hover": { textDecoration: "underline" } }}>
                <ChevronRight fontSize="small" sx={{ mr: 1, background: '#FFCC00', borderRadius: '50%', color: 'black' }} /> {text}
              </Typography>
            ))}
          </Grid>

          {/* Payment Methods */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" fontWeight="bold">Available Payment Methods</Typography>
            <Box mt={1} display="flex" gap={1}>
              <img src={paymentMethod} alt="Zoodonix payemnt methods logo" />
            </Box>
            <Typography sx={{ mt: 2 }}>
              We care about you and the safety of your purchases! All our products are 100% Safe, Secure and Verified Files!
            </Typography>
            <Box mt={1} display="flex" gap={1}>
              <img src={imgae1} alt="Zoodonix McAfee" />
            </Box>
          </Grid>
        </Grid>


        {/* Popular Tags */}
        <Typography
          variant="h6"
          gutterBottom
          sx={{
            textTransform: "uppercase",
            fontWeight: "bold",
            paddingTop: "40px",
            color: "white",
          }}
          className="text-white"
        >
          Popular Tags
        </Typography>
        <p
          className="popular-tags"
          style={{ margin: "0px", color: "white" }} 
        >
          <a href="#" style={{ color: "white", textDecoration: "none" }}>
            Website Development Company Near me
          </a>{" "}
          |{" "}
          <a href="#" style={{ color: "white", textDecoration: "none" }}>
            Website Developer in Guwahati
          </a>{" "}
          |{" "}
          <a href="#" style={{ color: "white", textDecoration: "none" }}>
            Best Website Designing Company in Guwahati
          </a>{" "}
          |{" "}
          <a href="#" style={{ color: "white", textDecoration: "none" }}>
            Website Builder Near Me
          </a>{" "}
          |{" "}
          <a href="#" style={{ color: "white", textDecoration: "none" }}>
            App Developer Near Me
          </a>{" "}
          |{" "}
          <a href="#" style={{ color: "white", textDecoration: "none" }}>
            Mobile App Developer Near Me
          </a>{" "}
          |{" "}
          <a href="#" style={{ color: "white", textDecoration: "none" }}>
            Mobile App Developer Near Assam
          </a>{" "}
          |{" "}
          <a href="#" style={{ color: "white", textDecoration: "none" }}>
            Internet Website Designers
          </a>{" "}
          |{" "}
          <a href="#" style={{ color: "white", textDecoration: "none" }}>
            Digital Marketing Services Guwahati
          </a>{" "}
          |{" "}
          <a href="#" style={{ color: "white", textDecoration: "none" }}>
            Internet Website Designers in Kolkata
          </a>{" "}
          |{" "}
          <a href="#" style={{ color: "white", textDecoration: "none" }}>
            Internet Website Designers in West Bengal
          </a>{" "}
          |{" "}
          <a href="#" style={{ color: "white", textDecoration: "none" }}>
            Internet Website Designers in Howrah
          </a>{" "}
          |{" "}
          <a href="#" style={{ color: "white", textDecoration: "none" }}>
            Internet Website Designers in Delhi
          </a>{" "}
          |{" "}
          <a href="#" style={{ color: "white", textDecoration: "none" }}>
            Internet Website Designers in Mumbai
          </a>{" "}
          |{" "}
          <a href="#" style={{ color: "white", textDecoration: "none" }}>
            Internet Website Designers in Chennai
          </a>{" "}
          |{" "}
          <a href="#" style={{ color: "white", textDecoration: "none" }}>
            Internet Website Designers in Hyderabad
          </a>{" "}
          |{" "}
          <a href="#" style={{ color: "white", textDecoration: "none" }}>
            Internet Website Developers in Tamil Nadu
          </a>{" "}
          |{" "}
          <a href="#" style={{ color: "white", textDecoration: "none" }}>
            Internet Website Developers in Rajasthan
          </a>{" "}
          |{" "}
          <a href="#" style={{ color: "white", textDecoration: "none" }}>
            Best Website Designing Company in Guwahati
          </a>{" "}
          |{" "}
          <a href="#" style={{ color: "white", textDecoration: "none" }}>
            Internet Website Designers in Nadia
          </a>{" "}
          |{" "}
          <a href="#" style={{ color: "white", textDecoration: "none" }}>
            Internet Website Designers in Saltlake
          </a>{" "}
          |{" "}
          <a href="#" style={{ color: "white", textDecoration: "none" }}>
            Internet Website Designers in Bidhannagar
          </a>{" "}
          |{" "}
          <a href="#" style={{ color: "white", textDecoration: "none" }}>
            Internet Website Designers in Dum Dum
          </a>{" "}
          |{" "}
          <a href="#" style={{ color: "white", textDecoration: "none" }}>
            Internet Website Designers in Belgharia
          </a>{" "}
          |{" "}
          <a href="#" style={{ color: "white", textDecoration: "none" }}>
            Internet Website Designers in Park Street
          </a>{" "}
          |{" "}
          <a href="#" style={{ color: "white", textDecoration: "none" }}>
            Internet Website Designers in Joynagar
          </a>{" "}
          |{" "}
          <a href="#" style={{ color: "white", textDecoration: "none" }}>
            Internet Website Designers in Newtown
          </a>{" "}
          |{" "}
          <a href="#" style={{ color: "white", textDecoration: "none" }}>
            Internet Website Designers in Laketown
          </a>{" "}
          |{" "}
          <a href="#" style={{ color: "white", textDecoration: "none" }}>
            Internet Website Designers in Kharagpur
          </a>{" "}
          |{" "}
          <a href="#" style={{ color: "white", textDecoration: "none" }}>
            Internet Website Designers in Medinipur
          </a>
        </p>

        {/* Top Cities Where We Offer */}
        <Typography
          variant="h6"
          gutterBottom
          sx={{
            textTransform: "uppercase",
            fontWeight: "bold",
            paddingTop: "40px",
            color: "white", // Make sure the heading is also white
          }}
          className="text-white"
        >
          Top Cities Where We Offer Web Development Services
        </Typography>
        <div
          className="text-white popular-tags"
          style={{ marginTop: "0px", color: "white", textDecoration: "none" }}
        >
          <a href="#" style={{ color: "white", textDecoration: "none" }}>
            App development company in Mumbai
          </a>{" "}
          |{" "}
          <a href="#" style={{ color: "white", textDecoration: "none" }}>
            App development company in Delhi
          </a>{" "}
          |{" "}
          <a href="#" style={{ color: "white", textDecoration: "none" }}>
            App development company in Bangalore
          </a>{" "}
          |{" "}
          <a href="#" style={{ color: "white", textDecoration: "none" }}>
            App development company in Hyderabad
          </a>{" "}
          |{" "}
          <a href="#" style={{ color: "white", textDecoration: "none" }}>
            App development company in Chennai
          </a>{" "}
          |{" "}
          <a href="#" style={{ color: "white", textDecoration: "none" }}>
            App development company in Kolkata
          </a>{" "}
          |{" "}
          <a href="#" style={{ color: "white", textDecoration: "none" }}>
            App development company in Pune
          </a>{" "}
          |{" "}
          <a href="#" style={{ color: "white", textDecoration: "none" }}>
            App development company in Ahmedabad
          </a>{" "}
          |{" "}
          <a href="#" style={{ color: "white", textDecoration: "none" }}>
            App development company in Jaipur
          </a>{" "}
          |{" "}
          <a href="#" style={{ color: "white", textDecoration: "none" }}>
            App development company in Surat
          </a>{" "}
          |{" "}
          <a href="#" style={{ color: "white", textDecoration: "none" }}>
            App development company in Lucknow
          </a>{" "}
          |{" "}
          <a href="#" style={{ color: "white", textDecoration: "none" }}>
            Web design company Coimbatore
          </a>{" "}
          |{" "}
          <a href="#" style={{ color: "white", textDecoration: "none" }}>
            Website designer in Kochi
          </a>{" "}
          |{" "}
          <a href="#" style={{ color: "white", textDecoration: "none" }}>
            Website designer in Chandigarh
          </a>
        </div>



        {/* Footer Bottom */}
        <Box
          mt={4}
          borderTop="1px solid rgba(255,255,255,0.2)"
          pt={2}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          flexWrap="wrap"
          sx={{
            gap: { xs: 2, md: 4 },
            flexDirection: { xs: "column", md: "row" },
            textAlign: { xs: "center", md: "left" },
          }}
        >
          {/* Copyright Text */}
          <Typography
            variant="body2"
            sx={{
              color: "yellow",
              maxWidth: "100%",
              wordBreak: "break-word",
              textAlign: { xs: "center", md: "left" },
            }}
          >
            © 2025 <strong>ZOODONIX TECHNOLOGIES (OPC) PRIVATE LIMITED</strong>
          </Typography>
          {/* Policy Links - Hidden on Mobile */}
          <Box
            display={{ xs: "none", md: "flex" }} // Hide on mobile, show on desktop
            gap={3} // Spacing between links
            flexWrap="wrap"
            justifyContent="flex-start"
          >
            {[
              "TERMS OF SERVICE",
              "PRIVACY POLICY",
              "SHIPPING POLICY",
              "REFUND POLICY",
              "COOKIES POLICY",
              "COPYRIGHT POLICY",
            ].map((text) => (
              <Typography
                key={text}
                component="a"
                href="#"
                sx={{
                  color: "white",
                  textDecoration: "none",
                  fontSize: "14px",
                  "&:hover": { textDecoration: "underline" }, // Hover effect
                }}
              >
                {text}
              </Typography>
            ))}
          </Box>

        </Box>





      </Box>


    </Box>
  );
};

export default Footer;
